const initialState = {};

initialState.config = {
	leftMenu: [],
	translate: {},
	load: false,
	contentLoad: false,
	path: null,
	currencies: [],
	systemSettings: {},
	infoBanner: {
		message: '',
		icon: '',
		type: '',
	},
};
initialState.config.translate = {
	label: {},
	enum: {},
};
initialState.user = {
	id: null,
	email: null,
	username: null,
	firstName: null,
	lastName: null,
	nickame: null,
	sysadmin: 0,
	language: 'cz',
	photo: '',
	phone: '',
	dob: '',
	changes: {},
	rights: {},
	darkMode: true,
	dashboardSettings: {
		numberOfRows: 2,
		numberOfColumns: 2,
	},
};
initialState.view = {
	module: null,
	recordId: null,
	detail: {},
	list: {},
	report: {},
	predefinedFields: {},
	calendar: {
		reload: false,
	}
};
initialState.view.detail = {
	def:  [],
	fields: {},
	buttons: [],
	changes: {},
	subpanels: [],
	extraData: {},
	linesData: {
		def: [],
		lines: [],
	},
	isAfterSave: false,
};
initialState.view.list = {
	header:  [],
	data: [],
	buttons: [],
	sort: [],
	selected: [],
	timeline: null,
};
initialState.dashboard = [];
initialState.toast = [];
initialState.popups = [];

export default initialState;
